import { useSelector } from 'react-redux';
import { Package } from '../../../types/package';
import PackageItems from '../../common/items/PackageItems';
import ConfirmationModal from '../../modals/ConfirmationModal';
import { selectCurrentShowTypeOfModal } from '../../../features/modal/modalSlice';
import { selectPackageStatus } from '../../../features/package/packageSlice';
import { useMutationData } from '../../../hooks/api/useMutationData';
import usePackageAction from '../../../hooks/actions/usePackageAction';
import { useMemo } from 'react';

interface PackageGroupProps {
    groupedPackages: Record<string, Package[]>;
    typeOfUser: 'admin' | 'user' | undefined;
}

export default function PackageGroup({groupedPackages, typeOfUser }: PackageGroupProps) {
    
    const typeOfModalShow = useSelector(selectCurrentShowTypeOfModal);
    const packageStatus = useSelector(selectPackageStatus); 
    const currentStatus = packageStatus.status
    const currentPackageName = packageStatus?.packageName ?? '';
    const { isLoadingUpdatePackageStatus, isLoadingUpdateSpecialPackageStatus, } = useMutationData()
    const isLoading = isLoadingUpdateSpecialPackageStatus || isLoadingUpdatePackageStatus
    const { handleUpdatePackageStatus, handleCancelUpdatePackageStatus } = usePackageAction()

    const sortedGroupedPackages = useMemo(() => {
        return Object.fromEntries(
            Object.entries(groupedPackages).map(([type, packages]) => [
                type,
                [...packages].sort((a, b) =>
                    a.packageName.localeCompare(b.packageName)
                ),
            ])
        );
    }, [groupedPackages]);

    return (
        <>
            {Object.entries(sortedGroupedPackages).map(([type, packages]) => (
                <div key={type} className="mb-4">
                    <h3 className="text-sm font-semibold mb-1">{type}</h3>
                    <hr className="border-gray-300 mb-2" />
                    <div className='grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-3 lg:grid-cols-4 lg:gap-3 overflow-hidden'>
                        {packages.map((pack) => {
                            return (
                                <PackageItems key={pack.packageID} pack={pack} typeOfUser={typeOfUser} />
                            )}
                        )}
                    </div>
                </div>
            ))}
            {typeOfModalShow === 'isUpdateStatusOfPackage' && (
                <ConfirmationModal 
                    onConfirm={handleUpdatePackageStatus} 
                    onCancel={handleCancelUpdatePackageStatus}
                    modalTitle='Update package status'
                    modalSubTitle={
                        <>
                            Are you sure you want to {currentStatus} this{" "}
                            <span className="font-semibold">{currentPackageName}</span> package?
                        </>
                    }
                    isLoading={isLoading}
                />
            )}
        </>
    )
}
